import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideNotification } from './ducks/notifications.js';

import Notifications from './notifications.js';

const mapStateToProps = state => ({
	shouldOpen: state.notifications.shouldOpen,
	message: state.notifications.message,
	messageKey: state.notifications.messageKey,
	title: state.notifications.title,
	titleKey: state.notifications.titleKey,
	icon: state.notifications.icon,
	color: state.notifications.color,
	buttonLink: state.notifications.buttonLink,
	linkCB: state.notifications.linkCB,
	buttonLinkInternal: state.notifications.buttonLinkInternal,
	buttonText: state.notifications.buttonText,
	buttonTextKey: state.notifications.buttonTextKey,
	buttonInline: state.notifications.buttonInline,
	buttonCB: state.notifications.buttonCB,
	centerAligned: state.notifications.centerAligned,
	openInSidebar: state.notifications.openInSidebar,
	onCloseClickCallback: state.notifications.onCloseClickCallback,
	onBluebarClick: state.notifications.onBluebarClick,
	customMargin: state.notifications.customMargin,
	buttonBottom: state.notifications.buttonBottom
});
/**
 * @param {any} dispatch redux state
 */
const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(
		{
			hideNotification
			// promptNemID,
			// hydrateNemID
		},
		dispatch
	)
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
